import { render, staticRenderFns } from "./EditPhoneNumberModal.vue?vue&type=template&id=a4d8d076&"
import script from "./EditPhoneNumberModal.vue?vue&type=script&lang=ts&"
export * from "./EditPhoneNumberModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports